import styled from 'styled-components';
import { colors } from 'styles';
import { LoaderCircle } from 'lucide-react';

export const Container = styled.div.attrs({
  className: 'w-full max-w-6xl p-4 pb-[150px]',
})``;

export const Heading = styled.p.attrs({
  className: 'text-sm font-medium mb-1',
})``;

export const SubHeading = styled.p.attrs({
  className: 'text-xs text-muted-foreground mb-3',
})``;

export const ResultSectionsWrapper = styled.div.attrs({
  className: 'bg-card border border-border rounded-xl shadow-sm space-y-4 p-4',
})``;

export const ImmunizationSlot = styled.div.attrs({
  className: 'mt-4 empty:hidden',
})``;

export const SelfAnamnesisChip = styled.span.attrs({
  className: 'px-2 py-0.5 text-xs font-medium rounded-sm',
})`
  background-color: ${colors.vantisViolet};
  border-color: ${colors.vantisViolet};
  color: ${colors.primaryForeground};
`;

export const SummaryTranscriptTabs = styled.div.attrs({
  role: 'tablist',
  className: 'mb-4 flex w-full max-w-[300px] mx-auto rounded-xl bg-muted p-1 gap-0.5',
})``;

export const SummaryTranscriptTab = styled.button.attrs<{
  $isActive: boolean;
}>(({ $isActive }) => ({
  type: 'button',
  role: 'tab',
  'data-ph-no-autocapture': true,
  className: `flex-1 min-w-0 rounded-xl px-3 py-2 text-sm font-medium transition-colors ${
    $isActive
      ? 'bg-white text-foreground border border-border shadow-sm'
      : 'text-muted-foreground border border-transparent hover:text-foreground'
  }`,
}))<{ $isActive: boolean }>``;

// Shared by ResultSummaryTab (the "waiting for more diagnoses" placeholder) and DiagnosisSection
// (the inline pendingMoreDiagnoses row) — neither widget owns these exclusively.
export const DiagnosisLoadingCard = styled.div.attrs({
  className: 'rounded-md border border-border bg-card px-4 py-3',
})``;

export const DiagnosisLoadingRow = styled.div.attrs({
  className: 'flex items-center gap-2 text-sm text-muted-foreground',
})``;

export const DiagnosisLoadingSpinner = styled(LoaderCircle).attrs({
  className: 'h-4 w-4 shrink-0 animate-spin',
})``;
